// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1fp4r","head":"Table_head__3iX58","col":"Table_col__IO-j3"};